import React from 'react';
import CTA2 from "../cta/CTA2";

const Error404 = () => {
    return (
        <div style={{ textAlign: 'center', marginTop: '10%' }}>
            <CTA2 />
        </div>
    );
};

export default Error404;
